import React, {useRef, useState, useCallback, useEffect} from 'react';
import { connect } from "react-redux";
import {isMobile} from 'react-device-detect';
import {
    NONE,
    RANDOMIZE,
    ACCUMULATE} from 'constants/aux-event-types.js';
import {useParameterMouse, getHeight} from './useParameterMouse.js';
import {
    setEffectParameterValue,
    setEffectParameterValues,
} from 'actions/index.js';

const AUX_EVENTS = ['Aux Event A', 'Aux Event B', 'Aux Event C', 'Aux Event D'];
const ROUNDS = ["Transpose"]; // "Aux Event A", "Aux Event B", "Aux Event C", "Aux Event D"];
const TOTAL_HEIGHT = isMobile ? 90 : 60;
const PARAM_ROOTS = {
    "Duration": 4,
    "Velocity": 1.5,
    "Aux Event A": 1.5,
    "Aux Event B": 1.5,
    "Aux Event C": 1.5,
    "Aux Event D": 1.5,
};

const needsRounding = (parameter, track) => {
    let auxType = getAuxType(parameter, track);
    const roundAuxes = ["transpose", "chop"];
    let variable = auxType && track.getAuxVariable(parameter.name);
    return ROUNDS.includes(parameter.name) || roundAuxes.includes(variable);
};

function ParameterEditor({
    setEffectParameterValue,
    setEffectParameterValues,
    track,
    name,
    value,
    parameter,
    id,
    color,
    shouldRound=needsRounding(parameter, track),
    stepData,
    min=getMin(parameter, track),
    max=getMax(parameter, track),
    height=TOTAL_HEIGHT,
    units="",
    cirklonMode,
    selectedSteps=[],
    root=PARAM_ROOTS[parameter.name] || 1
}) {
    const ref = useRef(undefined);
    let style = {
        height: getHeight(value, min, max, height, root),
        backgroundColor: color
    };

    let helperStyle = {
        bottom: getHeight(track.trackData.parameters.find(x => x.name === parameter.name).get(), min, max, height, root)
    };

    const getId = () => {
        return parameter.id;
    };

    const {onMouseDown, onMouseMove} = useParameterMouse({
        root,
        shouldRound,
        min,
        max,
        height,
        ref,
        setEffectParameterValue,
        track,
        stepData,
        setEffectParameterValues,
        parameter,
        cirklonMode,
        selectedSteps
    });
    
    const round = (x) => {
        return Math.round(x*100) / 100;
    };

    return (
        <div className="p-box">
          <div className="p-name">
            {name}
          </div>
          <div
            ref={ref}
            style={{height: height + 6}}
            id={getId()}
            onClick={(e) => e.stopPropagation()}
            onMouseMove={onMouseMove}
            onMouseDown={onMouseDown}
            className="volume-box">
            <div className="rest"/>
            <div
              style={style}
              className="volume-indicator">
            </div>
            <div style={helperStyle} className="helper-line"/>
        <div className="value">
          {round(value)}
        </div>
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        value: props.parameter.get() === null ? 
            props.trackParameter.get() : props.parameter.get(),
        v: state.effects.effectParameters[props.parameter.id],
        cirklonMode: state.cirklon.cirklonMode[props.track.id],
        selectedSteps: state.keyboard.selectedPianoRollSteps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setEffectParameterValue: (id, value) => dispatch(setEffectParameterValue(id, value)),
        setEffectParameterValues: (bulk) => dispatch(setEffectParameterValues(bulk))
    };
};
 
const getMin = (p, track) => {
    if (!AUX_EVENTS.includes(p.name)) {
        return p.min;
    }
    return 0;
};

const getAuxType = (p, track) => {
    switch (p.name) {
    case 'Aux Event A':
        return track.auxEventAType;
    case 'Aux Event B':
        return track.auxEventBType;
    case 'Aux Event C':
        return track.auxEventCType;
    case 'Aux Event D':
        return track.auxEventDType;
    }
}

const getMax = (p, track) => {
    if (!AUX_EVENTS.includes(p.name)) {
        if (p.name === "Slice") {
            let samplers = track.getSamplers();
            let sampler = samplers[0];
            return (sampler && sampler.slices.length - 1) || 0;
        }
        return p.max;
    }
    let type  = getAuxType(p, track);
    let variable = track.getAuxVariable(p.name);
    switch (variable) {
   case "transpose":
        return 32;
    case "duration":
        return 8;
    case "velocity":
        return 1;
    case "chop":
        return 16;
    case "panning":
        return 1;
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ParameterEditor);
